import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/statement/list", {
    type: "record",
    ...params,
  });
};

export const splitSubmissionFile = async (params) => {
  return await fetchFinance("/output/split", { ...params });
};

export const submitFile = async (params) => {
  return await fetchFinance("/action", {
    action: "submitSettlePlan",
    ...params,
  });
};

export const exportCsv = async () => {
  return await fetchFinance("/output/report", {});
};
